// extracted by mini-css-extract-plugin
export default {"gridContainer":"TaskList_gridContainer__N2yiO"};